import { CompetitionInfo } from './../../../../../data/mygolf.data';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-full-info-modal',
  templateUrl: './full-info-modal.page.html',
  styleUrls: ['./full-info-modal.page.scss'],
})
export class FullInfoModalPage implements OnInit {
  competition: CompetitionInfo;

  constructor(private viewCtrl: ModalController, private navParams: NavParams) {
    this.viewCtrl = viewCtrl;
    this.navParams = navParams;
    this.competition = navParams.get('competition');
  }

  ngOnInit() {}
  close() {
    this.viewCtrl.dismiss();
  }
}
